'use client'

import Image from 'next/image'
import { useEffect, useRef } from 'react'

interface SocialsMediaProps {
  src: string
  poster?: string
}

const SocialsMedia = ({ src, poster }: SocialsMediaProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (poster) return

    const video = videoRef.current
    if (!video) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.src = `${src}#t=0.001`
        } else {
          video.removeAttribute('src')
          video.load()
        }
      },
      { threshold: 0.01 },
    )

    observer.observe(video)
    return () => observer.disconnect()
  }, [src, poster])

  return (
    <div
      className={
        'relative h-[calc(250/16*1rem)] w-[calc(250/16*1rem)] md:h-[calc(270/16*1rem)] md:w-[calc(270/16*1rem)]'
      }
    >
      {poster ? (
        <Image
          src={poster}
          alt=""
          fill
          sizes="(min-width: 768px) 270px, 250px"
          className={'pointer-events-none object-cover'}
        />
      ) : (
        <video
          ref={videoRef}
          preload="metadata"
          className={'pointer-events-none h-full w-full object-cover'}
        />
      )}

      <div className={'absolute inset-0 flex items-center justify-center'}>
        <Image
          priority
          src={'/icons/play-circle.svg'}
          alt={'/icons/play-circle.svg'}
          height={52}
          width={52}
          className="size-13"
        />
      </div>
    </div>
  )
}

export default SocialsMedia
